/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line


  document.addEventListener("DOMContentLoaded", () => {
    /* -------------------- MAIN ITEMS DROPDOWN -------------------- */
    const mainDropdowns = document.querySelectorAll(".custom-dropdown [data-dropdown-toggle]");
    mainDropdowns.forEach(header => {
      header.addEventListener("click", e => {
        if (e.target.tagName.toLowerCase() === "a") return;

        const parent = header.parentElement;
        const menu = parent.querySelector(":scope > .custom-dropdown__menu");
        const isOpen = parent.classList.contains("open");

        if (menu) {
          if (isOpen) {
            menu.style.maxHeight = menu.scrollHeight + "px";
            requestAnimationFrame(() => menu.style.maxHeight = "0");
            parent.classList.remove("open");
          } else {
            menu.style.maxHeight = menu.scrollHeight + "px";
            parent.classList.add("open");
            menu.addEventListener("transitionend", function clearHeight() {
              if (parent.classList.contains("open")) {
                menu.style.maxHeight = "1000px";
              }
              menu.removeEventListener("transitionend", clearHeight);
            });
          }
        }
      });
    });

    /* -------------------- SUB ITEMS DROPDOWN -------------------- */
    const subDropdowns = document.querySelectorAll(".custom-dropdown [data-sub-dropdown-toggle]");
    subDropdowns.forEach(header => {
      header.addEventListener("click", e => {
        if (e.target.tagName.toLowerCase() === "a") return;

        const parent = header.parentElement;
        const submenu = parent.querySelector(":scope > .custom-dropdown__submenu");
        const isOpen = parent.classList.contains("open");

        if (submenu) {
          if (isOpen) {
            submenu.style.maxHeight = submenu.scrollHeight + "px";
            requestAnimationFrame(() => submenu.style.maxHeight = "0");
            parent.classList.remove("open");
          } else {
            submenu.style.maxHeight = submenu.scrollHeight + "px";
            parent.classList.add("open");
            submenu.addEventListener("transitionend", function clearHeight() {
              if (parent.classList.contains("open")) {
                submenu.style.maxHeight = "1000px";
              }
              submenu.removeEventListener("transitionend", clearHeight);
            });
          }
        }
      });
    });

    // Initialize open menus for active items
    document.querySelectorAll(".custom-dropdown__item.active, .custom-dropdown__subitem.active").forEach(item => {
      const menu = item.querySelector(":scope > .custom-dropdown__menu, :scope > .custom-dropdown__submenu");
      if (menu) {
        menu.style.maxHeight = menu.scrollHeight + "px";
        item.classList.add("open");
      }
    });

  });




  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
